// The core's skins for fixed blocks (level.statics[].skin). Without skin: 'counter'; unknown skin: purple.
import { C } from '../core/draw-helpers';
import type { SkinDef } from '../core/types';

export const skins: Record<string, SkinDef> = {
  shelf: { c1: C.wood1, c2: C.wood2, r: 9 },
  counter: { c1: C.mint1, c2: C.mint2, r: 10 },
  fridge: { c1: C.white1, c2: C.white2, r: 12 },
  leg: { c1: C.wood2, c2: C.wood3, r: 12 },
};
